export type CommissionAdministrationTranslation = {
  actor: string;
  amount: string;
  audit: string;
  earned: string;
  empty: string;
  inactive: string;
  markPaid: string;
  month: string;
  noAudits: string;
  offer: string;
  paid: string;
  paymentStatus: string;
  potential: string;
  process: string;
  profit: string;
  recipient: string;
  recipientType: {
    supervisor: string;
  };
  resetFilters: string;
  revertPayment: string;
  selectAll: string;
  selectOffer: string;
  status: {
    all: string;
    paid: string;
    toBePaid: string;
  };
  toBePaid: string;
  updatedAt: string;
  updateError: string;
};

export const commissionAdministrationTranslation: CommissionAdministrationTranslation = {
  actor: 'Administrator',
  amount: 'Kwota prowizji',
  audit: 'Audyt',
  earned: 'Zarobione',
  empty: 'Brak danych dla wybranych filtrów.',
  inactive: 'Nieaktywny',
  markPaid: 'Oznacz jako wypłacone',
  month: 'Miesiąc',
  noAudits: 'Brak zmian statusu.',
  offer: 'Oferta',
  paid: 'Wypłacone',
  paymentStatus: 'Status wypłaty',
  potential: 'Potencjalne',
  process: 'Proces',
  profit: 'Zysk oferty',
  recipient: 'Odbiorca',
  recipientType: { supervisor: 'Opiekun' },
  resetFilters: 'Wyczyść filtry',
  revertPayment: 'Cofnij wypłatę',
  selectAll: 'Zaznacz wszystkie widoczne prowizje',
  selectOffer: 'Zaznacz całą prowizję {{offer}}',
  status: {
    all: 'Wszystkie',
    paid: 'Wypłacone',
    toBePaid: 'Do wypłaty',
  },
  toBePaid: 'Do wypłaty',
  updatedAt: 'Czas zmiany',
  updateError: 'Nie udało się zmienić statusu wypłaty.',
};
